export enum CartType {
  Express = 'EXPRESS'
}
